import React from 'react';
import ListItem from 'components/ListItem';

import { FertilizerSupplier } from 'services/fertilizerEvents/types';

export interface OwnProps {
    supplier: FertilizerSupplier;
}

type Props = OwnProps;

export default function SummaryApplicationSupplierListItem(
    props: Props
): React.ReactElement {
    const { supplier } = props;

    return <ListItem description="Contractor" value={supplier} />;
}
